import { render } from "./IntegratedManagementContent.vue?vue&type=template&id=5e432127"
import script from "./IntegratedManagementContent.vue?vue&type=script&lang=js"
export * from "./IntegratedManagementContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.38_vue@3.2.13_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__